import type { Account, AccountType } from '@/types/db'
import type { ComboOption } from '@/components/ui/combobox'
import { accountIcon } from '@/lib/accountIcon'

const TYPE_LABELS: Record<AccountType, string> = {
  corrente: 'Contas correntes',
  poupanca: 'Poupança',
  cash: 'Cash',
  carteira: 'Carteira',
  investimento: 'Investimentos',
  cartao: 'Cartões',
}
const TYPE_ORDER: AccountType[] = ['corrente', 'poupanca', 'cash', 'carteira', 'investimento', 'cartao']

// Opções de conta para o Combobox, AGRUPADAS por tipo: um cabeçalho não-clicável
// por tipo (na ordem fixa) seguido das contas daquele tipo, ordenadas por nome e
// já com o emoji no rótulo. Reaproveitado por todos os seletores/filtros de conta.
export function accountComboOptions(accounts: Account[] | undefined): ComboOption[] {
  const byType = new Map<AccountType, Account[]>()
  for (const a of accounts ?? []) {
    if (!byType.has(a.type)) byType.set(a.type, [])
    byType.get(a.type)!.push(a)
  }
  const out: ComboOption[] = []
  for (const type of TYPE_ORDER) {
    const arr = byType.get(type)
    if (!arr || arr.length === 0) continue
    arr.sort((x, y) => x.name.localeCompare(y.name))
    out.push({ value: `__hdr_${type}`, label: TYPE_LABELS[type], header: true })
    for (const a of arr) out.push({ value: a.id, label: `${accountIcon(a)} ${a.name}` })
  }
  return out
}
